const getSerializedDataItem = (item) => {
    const { state, entryPoint, startPage } = item;
    return `${state}${entryPoint.replace(/[,%]/g, encodeURIComponent)},${startPage}`;
};
const getEncodedString = (input) => input.replace(/[&=;%]/g, encodeURIComponent);
/**
 * Manages serialization of a funnel cookie.
 * Funnel cookies are used to track user action funnels. Examples include: Registration, Post a Deal, New Thread Creation
 * See also: sd.cookies.js and SD_Analytics.js
 */
export default class CookieSerializerFunnel {
    /**
     * Deserialize input string into FunnelData
     *
     * @param {string} input
     */
    deserialize(input) {
        const data = {};
        if (!input) {
            return data;
        }
        input.split('&').forEach((keyValue) => {
            const [type, codedData] = keyValue.split('=');
            const decodedData = decodeURIComponent(codedData);
            const [entryPoint, startPage] = decodedData.substr(1).split(',');
            data[decodeURIComponent(type)] = {
                entryPoint,
                startPage,
                state: decodedData.substr(0, 1),
            };
        });
        return data;
    }
    /**
     * Serialize FunnelData into string
     *
     * @param {FunnelData} input
     */
    serialize(input) {
        return Object.entries(input).map(([type, data]) => {
            const cookieKey = getEncodedString(type);
            const serializedData = getSerializedDataItem(data);
            const cookieValue = getEncodedString(serializedData);
            return `${cookieKey}=${cookieValue}`;
        }).join('&');
    }
}
